import studentVehicle from '@/api/student-vehicle'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
    ...baseState,
    edit_data: {},
    operations: [],
    old_vehicle_id: ''
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_EDIT_DATA(state, data) {
        state.edit_data = data
    },
    SET_OPERATION(state, data) {
        state.operations = data
    },
    SET_OLD_VEHICLE_ID(state, data) {
        state.old_vehicle_id = data
    },
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                old_vehicle_id: context.state.old_vehicle_id
            },
            attrubutes
        )
        return studentVehicle.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },

    store(context, data) {
        return studentVehicle.store(data)
    },

    update(context, data) {
        return studentVehicle.update(data)
    },

    getVehicle(context, data) {
        return studentVehicle.vehicle(data)
    },
    getStudentRegister(context, vehicleId) {
        return studentVehicle.getStudentRegister(vehicleId);
    }
}
